import { render, staticRenderFns } from "./deleteStoreOrderUp.vue?vue&type=template&id=08dde7ee&scoped=true"
import script from "./deleteStoreOrderUp.vue?vue&type=script&lang=js"
export * from "./deleteStoreOrderUp.vue?vue&type=script&lang=js"
import style0 from "./deleteStoreOrderUp.vue?vue&type=style&index=0&id=08dde7ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dde7ee",
  null
  
)

export default component.exports